module.exports = __webpack_public_path__ + "img/ic_link_settings.9d44233a.svg";